const universalTools = ['Edit', 'Select'] as const;
export type UniversalTool = (typeof universalTools)[number];
export function isUniversalTool(tool: string): tool is UniversalTool {
  return universalTools.includes(tool as UniversalTool);
}

export const vectorTaggingShapeTools = [
  'Arrow',
  'Cuboid',
  'Keypoint',
  'Line',
  'Point',
  'Polygon',
  'Rectangle',
  'SliderRectangle',
] as const;

export type VectorTaggingShapeTool = (typeof vectorTaggingShapeTools)[number];

const vectorTaggingToolsObjectless = [
  ...vectorTaggingShapeTools,
  'Measure',
  'Zoom',
] as const;
export type VectorTaggingToolObjectless =
  (typeof vectorTaggingToolsObjectless)[number];

const vectorTaggingTools = [...vectorTaggingShapeTools, 'Measure'] as const;
export type VectorTaggingTool = (typeof vectorTaggingTools)[number];

function isVectorTaggingTool(tool: string): tool is VectorTaggingTool {
  return vectorTaggingTools.includes(tool as VectorTaggingShapeTool);
}

function isVectorTaggingToolObjectless(
  tool: string,
): tool is VectorTaggingToolObjectless {
  return vectorTaggingToolsObjectless.includes(
    tool as VectorTaggingToolObjectless,
  );
}

export type RasterCodingTool =
  | 'ColorSelect'
  | 'Fill'
  | 'Measure'
  | 'Paintbrush'
  | 'Superpixel'
  | 'Zoom';

export const pointCloudShapeTools = ['Cuboid'] as const;
const pointCloudTools = [...pointCloudShapeTools, 'Measure'] as const;
export type PointCloudTool = (typeof pointCloudTools)[number];
export function isPointCloudTool(tool: string): tool is PointCloudTool {
  return pointCloudTools.includes(tool as PointCloudTool);
}

export type ToolName =
  | UniversalTool
  | VectorTaggingToolObjectless
  | RasterCodingTool
  | PointCloudTool;

export function isUniversalOrPointCloudTool(
  toolName: string,
): toolName is UniversalTool | PointCloudTool {
  return isUniversalTool(toolName) || isPointCloudTool(toolName);
}

export function isUniversalOrVectorTaggingTool(
  toolName: string,
): toolName is UniversalTool | PointCloudTool {
  return isUniversalTool(toolName) || isVectorTaggingTool(toolName);
}

export function isUniversalOrVectorTaggingToolObjectless(
  toolName: string,
): toolName is UniversalTool | PointCloudTool {
  return isUniversalTool(toolName) || isVectorTaggingToolObjectless(toolName);
}
